import {$dom} from "./helpers/dom";
import Page from "./classes/Page";
import components from "./pages/regular/_components";

$dom.ready(function() {
    this.currentPage = new Page({
        name: 'regular',
        rootElementId: 'js-page-regular'
    });

    this.currentPage.init(components(this.currentPage));
});